import { Reference } from './Reference.interface';

// task
const SubTaskParentData: Reference = {
  name: 'SubTask Parent Data',
  typeName: 'SubTaskParentData',
  props: [
    { id: 'id', name: 'ID', type: 'number' },
    { id: 'key', name: 'Key', type: 'string' },
    { id: 'name', name: 'Name', type: 'string' },
    { id: 'version', name: 'Version', type: 'number' },
    { id: 'status', name: 'Status', type: 'string' }
  ]
};

const SubTaskUserGroupData: Reference = {
  name: 'SubTask User Group Data',
  typeName: 'SubTaskUserGroupData',
  props: [
    { id: 'id', name: 'ID', type: 'string' },
    { id: 'name', name: 'Group Name', type: 'string' }
  ]
};

const SubTaskUserData: Reference = {
  name: 'SubTask User Data',
  typeName: 'SubTaskUserData',
  props: [
    { id: 'id', name: 'ID', type: 'string' },
    { id: 'firstName', name: 'First Name', type: 'string' },
    { id: 'lastName', name: 'Last Name', type: 'string' },
    { id: 'email', name: 'Email', type: 'string' },
    { id: 'groups', name: 'Groups', type: SubTaskUserGroupData, isArray: true }
  ]
};

const SubTaskData: Reference = {
  name: 'SubTask Data',
  typeName: 'SubTaskData',
  props: [
    { id: 'id', name: 'ID', type: 'number' },
    { id: 'name', name: 'Name', type: 'string' },
    { id: 'version', name: 'Version', type: 'number' },
    { id: 'status', name: 'Status', type: 'string' },
    {
      id: 'statePath',
      name: 'State Path',
      type: 'string',
      description:
        'The status of the main Task when the SubTask was created (defaults to empty string if not provided)'
    },
    { id: 'reason', name: 'Reason', type: 'string' },
    { id: 'dueDate', name: 'Due Date', type: 'string' },
    {
      id: 'signedDate',
      name: 'Signed Date',
      type: 'string',
      description:
        'Date value becomes "N/A" if the Approver (User) has not approved/rejected the item yet'
    },
    { id: 'isSigned', name: 'Is Signed', type: 'boolean' },
    { id: 'isOptional', name: 'Is Optional', type: 'boolean' },
    { id: 'isDeleted', name: 'Is Deleted', type: 'boolean' },
    { id: 'created', name: 'Created Date', type: 'string' },
    { id: 'modified', name: 'Modified Date', type: 'string' },
    { id: 'parent', name: 'Parent Task', type: SubTaskParentData },
    { id: 'user', name: 'User (Assignee)', type: SubTaskUserData },
    { id: 'signedGroup', name: 'Signed Group', type: SubTaskUserGroupData }
  ]
};

const SubTaskGroupData: Reference = {
  name: 'SubTask Group Data',
  typeName: 'SubTaskGroupData',
  props: [
    { id: 'version', name: 'Version', type: 'number' },
    { id: 'tasks', name: 'Tasks', type: SubTaskData, isArray: true }
  ]
};

// CAPA
const CapaAttachmentTable: Reference = {
  name: 'Capa Attachments Table',
  typeName: 'CapaAttachmentTable',
  props: [
    {
      id: 'index',
      name: 'Index',
      type: 'number'
    },
    { id: 'title', name: 'Title', type: 'string' }
  ]
};
export const CapaReference: Reference = {
  name: 'Capa Template Reference',
  typeName: 'CapaTemplateReference',
  props: [
    { id: 'exportedDate', name: 'Exported Date', type: 'string' },
    { id: 'id', name: 'ID', type: 'string' },
    { id: 'title', name: 'Title', type: 'string' },
    { id: 'summary', name: 'Summary', type: 'string' },
    { id: 'source', name: 'Source', type: 'string' },
    { id: 'sourceReference', name: 'Source Reference', type: 'string' },
    { id: 'description', name: 'Description', type: 'string' },
    { id: 'capaOwner', name: 'Capa Owner', type: 'string' },
    { id: 'severity', name: 'Severity', type: 'string' },
    { id: 'probability', name: 'Probability', type: 'string' },
    { id: 'correctiveActions', name: 'Corrective Actions', type: 'string' },
    { id: 'investigator', name: 'Investigator', type: 'string' },
    {
      id: 'investigationStartDate',
      name: 'Investigation Start Date',
      type: 'string'
    },
    {
      id: 'investigationCompletedDate',
      name: 'Investigation Completed Date',
      type: 'string'
    },
    {
      id: 'implementationStartDate',
      name: 'Implementation Start Date',
      type: 'string'
    },
    {
      id: 'implementationCompletedDate',
      name: 'Implementation Completed Date',
      type: 'string'
    },
    { id: 'rootCause', name: 'Root Cause', type: 'string' },
    { id: 'rootCauseRationale', name: 'Root Cause Rationale', type: 'string' },
    { id: 'preventiveAction', name: 'Preventive Action', type: 'string' },
    { id: 'trainingNeeded', name: 'Training Needed', type: 'string' },
    { id: 'verification', name: 'Verification', type: 'string' },
    {
      id: 'verificationStartDate',
      name: 'Verification Start Date',
      type: 'string'
    },
    { id: 'closedDate', name: 'Closed Date', type: 'string' },
    { id: 'completedBy', name: 'Completed By', type: 'string' },
    {
      id: 'attachmentTable',
      name: 'Attachment Table',
      type: CapaAttachmentTable,
      isArray: true
    }
  ]
};

const DocumentApprovalFileData: Reference = {
  name: 'Document Approval File Data',
  typeName: 'DocumentApprovalFileData',
  props: [
    { id: 'id', name: 'File ID', type: 'string' },
    { id: 'name', name: 'File Name', type: 'string' },
    { id: 'status', name: 'File Status', type: 'string' },
    { id: 'version', name: 'Verion', type: 'number' }
  ]
};

const DocumentApprovalSubTaskUserData: Reference = {
  name: 'Document Approval SubTask User Data',
  typeName: 'DocumentApprovalSubTaskUserData',
  props: [
    ...SubTaskUserData.props,
    { id: 'signedGroup', name: 'Signed Group', type: SubTaskUserGroupData }
  ]
};

const DocumentApprovalSubTaskData: Reference = {
  name: 'Document Approval SubTask Data',
  typeName: 'DocumentApprovalSubTaskData',
  props: [
    { id: 'version', name: 'SubTask Version', type: 'number' },
    { id: 'status', name: 'SubTask Status', type: 'string' },
    {
      id: 'statePath',
      name: 'SubTask State Path',
      type: 'string',
      description:
        'The status of the main Task when the SubTask was created (defaults to empty string if not provided)'
    },
    {
      id: 'signedDate',
      name: 'Signed Date',
      type: 'string',
      description:
        'Date value becomes "N/A" if the Approver (User) has not approved/rejected the item yet'
    },
    { id: 'modifiedDate', name: 'Last Modified Date', type: 'string' },
    {
      id: 'user',
      name: 'Assignee (SubTask User)',
      type: DocumentApprovalSubTaskUserData
    }
  ]
};

const DocumentChangeHistoryData: Reference = {
  name: 'Document Change History Data',
  typeName: 'DocumentChangeHistoryData',
  props: [
    { id: 'version', name: 'Version', type: 'number' },
    {
      id: 'descriptionOfChange',
      name: 'Description Of Change',
      type: 'string'
    },
    { id: 'reasonForChange', name: 'Reason For Change', type: 'string' }
  ]
};

export const DocumentApprovalReference: Reference = {
  name: 'Document Approval Reference',
  typeName: 'DocumentApprovalTemplateReference',
  props: [
    {
      id: 'message',
      name: 'Message',
      type: 'string',
      description: 'Custom message'
    },
    { id: 'exportedDate', name: 'Exported Date', type: 'string' },
    { id: 'downloadDate', name: 'Download Date', type: 'string' },
    { id: 'dueDate', name: 'Due Date', type: 'string' },
    { id: 'file', name: 'File Data', type: DocumentApprovalFileData },
    {
      id: 'changeHistory',
      name: 'Change History',
      type: DocumentChangeHistoryData,
      isArray: true
    },
    {
      id: 'subTasks',
      name: 'Approvers (SubTasks)',
      type: DocumentApprovalSubTaskData,
      isArray: true
    },
    {
      id: 'subTaskVersions',
      name: 'Version Approvals',
      type: SubTaskGroupData,
      isArray: true,
      description:
        'List of all version approvals grouped by version including the current/latest approvals.'
    }
  ]
};

// Employee Training
const TraineeData: Reference = {
  name: 'Trainee Data',
  typeName: 'TraineeData',
  props: [
    { id: 'id', name: 'ID', type: 'string' },
    { id: 'name', name: 'Name', type: 'string' },
    { id: 'email', name: 'Email', type: 'string' },
    { id: 'status', name: 'Status', type: 'string' }
  ]
};
const TraineeProgressData: Reference = {
  name: 'Trainee Progress Data',
  typeName: 'TraineeProgressData',
  props: [
    { id: 'toDo', name: 'To Do', type: 'number' },
    { id: 'inProgress', name: 'In Progress', type: 'number' },
    { id: 'completed', name: 'Completed', type: 'number' },
    { id: 'total', name: 'Total', type: 'number' }
  ]
};
const TraineeLogData: Reference = {
  name: 'Trainee Log Data',
  typeName: 'TraineeLogData',
  props: [
    { id: 'id', name: 'ID', type: 'string' },
    { id: 'name', name: 'Name', type: 'string' },
    { id: 'status', name: 'Status', type: 'string' },
    { id: 'version', name: 'Verion', type: 'number' },
    { id: 'assignedDate', name: 'Assignee Data', type: 'string' },
    { id: 'dueDate', name: 'Due Date', type: 'string' },
    { id: 'completedDate', name: 'Completed Date', type: 'string' }
  ]
};
const TraineeFileData: Reference = {
  name: 'Trainee File Data',
  typeName: 'TraineeFileData',
  props: [
    { id: 'id', name: 'ID', type: 'string' },
    { id: 'trainingId', name: 'Training Id', type: 'string' },
    { id: 'name', name: 'Name', type: 'string' },
    { id: 'number', name: 'Number', type: 'number' },
    { id: 'version', name: 'Version', type: 'number | string' },
    { id: 'status', name: 'Status', type: 'string' },
    { id: 'assignedDate', name: 'Assigned Date', type: 'string' },
    { id: 'dueDate', name: 'Due Date', type: 'string' },
    { id: 'completedDate', name: 'Completed Date', type: 'string' }
  ]
};
export const EmployeeTrainingReference: Reference = {
  name: 'Employee Training Template Reference',
  typeName: 'EmployeeTrainingTemplateReference',
  props: [
    { id: 'exportedDate', name: 'Exported Date', type: 'string' },
    { id: 'trainee', name: 'Trainee', type: TraineeData },
    { id: 'progress', name: 'Progress', type: TraineeProgressData },
    { id: 'logs', name: 'Logs', type: TraineeLogData, isArray: true },
    { id: 'documents', name: 'Documents', type: TraineeFileData, isArray: true }
  ]
};

// Training Plan
const TrainingLinkedDocuments: Reference = {
  name: 'Training Linked Documents',
  typeName: 'TrainingLinkedDocuments',
  props: [
    { id: 'linkedDocumentName', name: 'Linked Document Name', type: 'string' },
    {
      id: 'linkedDocumentVersion',
      name: 'Linked Document Version',
      type: 'number'
    }
  ]
};

const TrainingUsersType: Reference = {
  name: 'Training Users',
  typeName: 'TrainingUsersType',
  props: [
    { id: 'userId', name: 'User ID', type: 'number' },
    { id: 'firstName', name: 'First Name', type: 'string' },
    { id: 'lastName', name: 'Last Name', type: 'string' },
    { id: 'teams', name: 'Teams', type: 'string' },
    { id: 'assignedDate', name: 'Assigned Date', type: 'string' },
    { id: 'dueDate', name: 'Due Date', type: 'string' },
    { id: 'completedDate', name: 'Completed Date', type: 'string' },
    { id: 'status', name: 'Status', type: 'string' }
  ]
};

const TrainingVersionData: Reference = {
  name: 'Training Version Data',
  typeName: 'TrainingVersionData',
  props: [
    { id: 'trainingPlanName', name: 'Training Plan Name', type: 'string' },
    { id: 'status', name: 'Status', type: 'string' },
    { id: 'version', name: 'Version', type: 'number' },
    {
      id: 'documents',
      name: 'Linked Documents',
      type: TrainingLinkedDocuments,
      isArray: true
    },
    {
      id: 'trainingUsers',
      name: 'Training Users',
      type: TrainingUsersType,
      isArray: true
    }
  ]
};

export const TrainingPlanReference: Reference = {
  name: 'Training Plan Template Reference',
  typeName: 'TrainingPlanTemplateReference',
  props: [
    { id: 'exportedDate', name: 'Exported Date', type: 'string' },
    { id: 'option', name: 'Option', type: 'string' },
    {
      id: 'trainingVersions',
      name: 'Training Versions',
      type: TrainingVersionData,
      isArray: true
    }
  ]
};

// Risk
const RiskTableData: Reference = {
  name: 'Risk Table Data',
  typeName: 'RiskTableData',
  props: [
    { id: 'id', name: 'ID', type: 'string' },
    { id: 'title', name: 'Title', type: 'string' },
    { id: 'relatedHazard', name: 'Related Hazard', type: 'string' },
    { id: 'hazardSituation', name: 'Hazard Situation', type: 'string' },
    { id: 'potentialHarm', name: 'Potential Harm', type: 'string' },
    { id: 'potentialCauses', name: 'Potential Causes', type: 'string' },
    { id: 'relevance', name: 'Relevance', type: 'string' },
    { id: 'currentControls', name: 'Current Controls', type: 'string' },
    { id: 'recommendedActions', name: 'Recommended Actions', type: 'string' },
    { id: 'actionsTaken', name: 'Actions Taken', type: 'string' },
    { id: 'verification', name: 'Verification', type: 'string' },
    { id: 'p1', name: 'P1', type: 'number' },
    { id: 'o1', name: 'O2', type: 'number' },
    { id: 's1', name: 'S1', type: 'number' },
    { id: 'd1', name: 'D1', type: 'number' },
    { id: 'p2', name: 'P2', type: 'number' },
    { id: 'o2', name: 'O2', type: 'number' },
    { id: 's2', name: 'S2', type: 'number' },
    { id: 'd2', name: 'D2', type: 'number' },
    { id: 'rpn1', name: 'RPN 1', type: 'number' },
    { id: 'r1', name: 'R1', type: 'string' },
    { id: 'rpn2', name: 'RPN 2', type: 'number' },
    { id: 'r2', name: 'R2', type: 'string' },
    { id: 'ref', name: 'Reference', type: 'string' }
  ]
};
export const RiskReference: Reference = {
  name: 'Risk Template Reference',
  typeName: 'RiskTemplateReference',
  props: [
    { id: 'exportedDate', name: 'Exported Date', type: 'string' },
    { id: 'table', name: 'Table', type: RiskTableData, isArray: true }
  ]
};

// Change Order
const ChangeOrderSubTasksData: Reference = {
  name: 'Change Order SubTasks Data',
  typeName: 'ChangeOrderSubTasksData',
  props: [
    {
      id: 'latest',
      name: 'Latest Approvals',
      type: SubTaskGroupData,
      isArray: true,
      description: 'List of all current approvals grouped by version.'
    },
    {
      id: 'versions',
      name: 'Version Approvals',
      type: SubTaskGroupData,
      isArray: true,
      description:
        'List of all version approvals grouped by version including the current/latest approvals.'
    }
  ]
};

const ChangeOrderData: Reference = {
  name: 'Change Order Data',
  typeName: 'ChangeOrderData',
  props: [
    { id: 'id', name: 'ID', type: 'string' },
    { id: 'name', name: 'Name', type: 'string' },
    { id: 'typeOfChange', name: 'Type Of Change', type: 'string' },
    { id: 'urgentChange', name: 'Urgent Change', type: 'string' },
    { id: 'description', name: 'Description', type: 'string' },
    { id: 'reasonForChange', name: 'Reason For Change', type: 'string' },
    { id: 'affectedParts', name: 'Affected Parts', type: 'string' },
    { id: 'requestDate', name: 'Request Date', type: 'string' },
    { id: 'requestor', name: 'Requestor', type: 'string' },
    { id: 'impactOfChange', name: 'Impact Of Change', type: 'string' },
    {
      id: 'changeToTrainingMatrix',
      name: 'Change To Training Matrix',
      type: 'string'
    },
    { id: 'comments', name: 'Comments', type: 'string' },
    {
      id: 'productDesignAssessment',
      name: 'Product Design Assessment',
      type: 'string'
    },
    {
      id: 'productRiskAssessment',
      name: 'Product Risk Assessment',
      type: 'string'
    },
    {
      id: 'affectedDocuments',
      name: 'Affected Documents',
      type: 'string'
    },
    {
      id: 'regulatoryAssessment',
      name: 'Regulatory Assessment',
      type: 'string'
    },
    {
      id: 'qualityAssessment',
      name: 'Quality Assessment',
      type: 'string'
    },
    {
      id: 'labellingAssessment',
      name: 'Labelling Assessment',
      type: 'string'
    },
    {
      id: 'manufacturingAssessment',
      name: 'Manufacturing Assessment',
      type: 'string'
    },
    {
      id: 'supplierAssessment',
      name: 'Supplier Assessment',
      type: 'string'
    },
    {
      id: 'clinical',
      name: 'Clinical',
      type: 'string'
    },
    {
      id: 'reviewAndApproveChangeComments',
      name: 'Comments',
      type: 'string'
    },
    {
      id: 'productDesignActions',
      name: 'Product (design/ software) actions',
      type: 'string'
    },
    {
      id: 'productRiskActions',
      name: 'Product Risk actions',
      type: 'string'
    },
    {
      id: 'regulatoryActions',
      name: 'Regulatory actions',
      type: 'string'
    },
    {
      id: 'qualityActions',
      name: 'Quality Actions',
      type: 'string'
    },
    {
      id: 'labellingActions',
      name: 'Labelling Actions',
      type: 'string'
    },
    {
      id: 'manufacturingActions',
      name: 'Manufacturing Actions',
      type: 'string'
    },
    {
      id: 'supplierActions',
      name: 'Supplier Actions',
      type: 'string'
    },
    {
      id: 'itSystemsActions',
      name: 'IT systems Actions',
      type: 'string'
    },
    {
      id: 'verifyEffectiveness',
      name: 'Verify effectiveness',
      type: 'string'
    },
    {
      id: 'changeRecordsAndDocumentationUpdated',
      name: 'Change records and documentation updated',
      type: 'string'
    },
    {
      id: 'assetInventoryNeedUpdated',
      name: 'Asset Inventory Need Updated',
      type: 'string'
    },
    {
      id: 'accessMatrixNeedUpdated',
      name: 'Access Matrix Need Updated',
      type: 'string'
    },
    {
      id: 'requireRiskAssessment',
      name: 'Require Ris kAssessment',
      type: 'string'
    },
    {
      id: 'requireAssetDowntime',
      name: 'Require Asset Downtime',
      type: 'string'
    },
    {
      id: 'itDueDate',
      name: 'IT Due Date',
      type: 'string'
    },
    {
      id: 'itCompletedDate',
      name: 'IT Completed Date',
      type: 'string'
    },
    {
      id: 'itComments',
      name: 'IT Comments',
      type: 'string'
    },
    { id: 'openPo', name: 'Open Po', type: 'string' },
    { id: 'incomingInspection', name: 'Incoming Inspection', type: 'string' },
    { id: 'wip', name: 'WIP', type: 'string' },
    { id: 'quarantineOrHold', name: 'Quarantine / Hold', type: 'string' },
    { id: 'field', name: 'Field', type: 'string' },
    { id: 'commentsInventory', name: 'Comments Inventory', type: 'string' },
    { id: 'fieldActionReview', name: 'Field Action Review', type: 'string' },
    {
      id: 'hazardAssessmentReview',
      name: 'Hazard Assessment Review',
      type: 'string'
    },
    {
      id: 'designVerificationReview',
      name: 'Design Verification Review',
      type: 'string'
    },
    {
      id: 'designReviewAttached',
      name: 'Design Review Attached',
      type: 'string'
    },
    { id: 'changeCompatibility', name: 'Change Compatibility', type: 'string' },
    {
      id: 'manufacturingQualityImpact',
      name: 'Manufacturing Quality Impact',
      type: 'string'
    },
    {
      id: 'changeSupplierImpact',
      name: 'Change Supplier Impact',
      type: 'string'
    },
    {
      id: 'productRegulatoryImpact',
      name: 'Product Regulatory Impact',
      type: 'string'
    },
    {
      id: 'changeSoftwareModification',
      name: 'Change Software Modification',
      type: 'string'
    },
    { id: 'dhfiUpdated', name: 'DHFI Updated', type: 'string' },
    { id: 'commentsProduct', name: 'Comments Product', type: 'string' },
    { id: 'labelingReview', name: 'Labeling Review', type: 'string' },
    {
      id: 'regulatoryRegistrationAffected',
      name: 'Regulatory Registration Affected',
      type: 'string'
    },
    { id: 'claimsAffected', name: 'Claims Affected', type: 'string' },
    { id: 'udiAffected', name: 'UDI Affected', type: 'string' },
    { id: 'printedLabelImpact', name: 'Printed Label Impact', type: 'string' },
    {
      id: 'labelProgramUpdated',
      name: 'Label Program Updated',
      type: 'string'
    },
    { id: 'testLabelAttached', name: 'Test Label Attached', type: 'string' },
    { id: 'commentsLabeling', name: 'Comments Labeling', type: 'string' },
    {
      id: 'processValidationImpact',
      name: 'Process Validation Impact',
      type: 'string'
    },
    { id: 'pfmeaImpact', name: 'PFMEA Impact', type: 'string' },
    { id: 'procedureImpact', name: 'Procedure Impact', type: 'string' },
    { id: 'safetyImpact', name: 'Safety Impact', type: 'string' },
    { id: 'sdsNeeded', name: 'SDS Needed', type: 'string' },
    { id: 'equipmentImpact', name: 'Equipment Impact', type: 'string' },
    { id: 'calibrationImpact', name: 'Calibration Impact', type: 'string' },
    {
      id: 'manufacturingRegulatoryImpact',
      name: 'Manufacturing Regulatory Impact',
      type: 'string'
    },
    {
      id: 'clinicalTrialImpact',
      name: 'Clinical Trial Impact',
      type: 'string'
    },
    {
      id: 'commentsManufacturing',
      name: 'Comments Manufacturing',
      type: 'string'
    },
    {
      id: 'supplierEvaluationCompleted',
      name: 'Supplier Evaluation Completed',
      type: 'string'
    },
    { id: 'ndaApplicable', name: 'NDA Applicable', type: 'string' },
    {
      id: 'supplierAgreementNeeded',
      name: 'Supplier Agreement Needed',
      type: 'string'
    },
    {
      id: 'termsConditionsImpact',
      name: 'Terms Conditions Impact',
      type: 'string'
    },
    {
      id: 'firstArticleRequired',
      name: 'First Article Required',
      type: 'string'
    },
    {
      id: 'inspectionProcedureImpact',
      name: 'Inspection Procedure Impact',
      type: 'string'
    },
    { id: 'commentsSupplier', name: 'Comments Supplier', type: 'string' },
    {
      id: 'triggeredPeriodicReview',
      name: 'Triggered Periodic Review',
      type: 'string'
    },
    {
      id: 'qualityChangeComponent',
      name: 'Quality Change Component',
      type: 'string'
    },
    {
      id: 'qualityChangeArchitecture',
      name: 'Quality Change Architecture',
      type: 'string'
    },
    {
      id: 'qualityChangeRequiredInput',
      name: 'Quality Change Required Input',
      type: 'string'
    },
    {
      id: 'qualityChangeNewDiagnostic',
      name: 'Quality Change New Diagnostic',
      type: 'string'
    },
    {
      id: 'qualityChangePresentation',
      name: 'Quality Change Presentation',
      type: 'string'
    },
    {
      id: 'qualityChangeDataRequired',
      name: 'Quality Change Data Required',
      type: 'string'
    },
    { id: 'qualityChangeRisks', name: 'Quality Change Risks', type: 'string' },
    {
      id: 'qualityChangeIntendedUse',
      name: 'Quality Change Intended Use',
      type: 'string'
    },
    { id: 'documentInteraction', name: 'Document Interaction', type: 'string' },
    {
      id: 'regulationAssessment',
      name: 'Regulation Assessment',
      type: 'string'
    },
    {
      id: 'commentsQualityDocument',
      name: 'Comments Quality Document',
      type: 'string'
    },
    {
      id: 'documentInteractionDescription',
      name: 'Document Interaction Description',
      type: 'string'
    },
    {
      id: 'ehsAssessmentDescription',
      name: 'EHS Assessment Description',
      type: 'string'
    },
    {
      id: 'regulationAssessmentOther',
      name: 'Regulation Assessment Other',
      type: 'string'
    },
    { id: 'commentsOther', name: 'Comments Other', type: 'string' },
    {
      id: 'trainingMatrixNeedUpdated',
      name: 'Training Matrix Need Updated',
      type: 'string'
    },
    {
      id: 'hangeImpactCompetencyAssessmentRequirements',
      name: 'Change Impact Competency Assessment Requirements',
      type: 'string'
    },
    {
      id: 'changeRequireOperatorQualifications',
      name: 'Change Require Operator Qualifications',
      type: 'string'
    },
    {
      id: 'changeRequireOperatorOrTrainingCertification',
      name: 'Change Require Operator Or Training Certification',
      type: 'string'
    },
    {
      id: 'subTasks',
      name: 'SubTasks (Approvals)',
      type: ChangeOrderSubTasksData
    }
  ]
};
export const ChangeOrderReference: Reference = {
  name: 'Change Order Template Reference',
  typeName: 'ChangeOrderTemplateReference',
  props: [
    { id: 'exportedDate', name: 'Exported Date', type: 'string' },
    { id: 'changeOrder', name: 'Change Order', type: ChangeOrderData }
  ]
};
